<template>
  <div id="app">
    <Header :shadow="headerPassed" />
    <div v-waypoint="{ active: true, callback: onHeaderWaypoint, options: headerOptions }" class="header-spacer">
    </div>
    <transition name="page" mode="out-in">
      <router-view class="router-content" />
    </transition>
    <Contact />
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Picker from './components/Picker.vue';
import Contact from './components/Contact.vue';

export default {
  name: 'app',
  components: {
    Header,
    Contact
  },
  data: () => ({
    headerPassed: false,
    headerOptions: {
      threshold: [ 0, 1 ]
    }
  }),
  methods: {
    onHeaderWaypoint ({ direction }) {
      this.$data.headerPassed = direction == this.$waypointMap.DIRECTION_TOP;
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/colors.scss';
@import '@/styles/sizes.scss';

html, body {
  margin: 0;
  background: $color-bg;
}

#app {
  margin: 0;
  background: $color-bg;
  color: $color-fg;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.router-content {
  padding: 0 0 120px;
}

.header-spacer {
  height: 64px;
}

h2 {
  margin: 36px 0 8px;
  font-size: 32px;

  @include break-phone {
    margin: 24px 0 6px;
    font-size: 28px;
  }
}

h3 {
  margin: 20px 0 6px;
  font-size: 22px;

  @include break-phone {
    margin: 6px 0;
    font-size: 22px;
  }
}

p {
  margin: 8px 0 6px;
}

button {
  cursor: pointer;
}

a {
  color: $color-fg;
}

.page-enter-active {
  transition: opacity 0.4s;
}

.page-leave-active {
  transition: opacity 0.4s;
}

.page-enter, .page-leave-to {
  opacity: 0;
}
</style>
